import {CompanyRole} from '@/constants';

export interface Manager {
  _id: string;
  email: string;
}

export interface Moderator {
  _id: string;
  email: string;
}

export interface Sport {
  key: string;
  labels: {
    [key: string]: string;
  };
  picture: string;
  _id: string;
}

export interface UserSport {
  sport: string | Sport;
  level: number;
}

export type SupportedLanguage = 'de' | 'en';

export interface TranslationLabels {
  de: string;
  en: string;
}

export type RoleChangeDetails = {
  employeeId: string;
  updatedRole: CompanyRole;
} | null;

export enum AppVariant {
  SPORTJOE = 'sportjoe',
  SJONE = 'sjone'
}

export enum DocumentType {
  EVENT = 'event',
  TEAM = 'team',
  COMPANY = 'company',
  P2P = 'p2p'
}

export enum DevicePlatform {
  IOS = 'ios',
  ANDROID = 'android',
  WEB = 'web'
}

export enum Role {
  USER = 'USER',
  USERPLUS = 'USERPLUS',
  SUPERUSER = 'SUPERUSER',
  ADMIN = 'ADMIN',
  SPORTJOE = 'SPORTJOE',
  TRAINER = 'TRAINER',
  CLUB_USER = 'CLUB_USER',
  CLUB_TRAINER = 'CLUB_TRAINER',
  CLUB_ADMIN = 'CLUB_ADMIN',
  CLUB_MEMBER = 'CLUB_MEMBER',
  CLUB_INSTITUTE = 'CLUB_INSTITUTE'
}
